import { TranslationObject } from '@ngx-translate/core';

export class AspectRankingComparison {
  location: TranslationObject;
  value: number;
  geoCode: string;
  geoType: string;

  constructor(
    location: TranslationObject,
    value: number,
    geoCode: string,
    geoType: string
  ) {
    this.location = location;
    this.value = value;
    this.geoCode = geoCode;
    this.geoType = geoType;
  }
}